/**
 * Iterates each consequetive pair in an array.
 * For example [0,1,2,3] will yield:
 * [0,1],[1,2],[2,3] when connectLastAndFirstPoint is false
 * and
 * [0,1],[1,2],[2,3],[3,0] when connectLastAndFirstPoint is true.
 */
export function* consequetivePairIterator<T>(
  array: T[],
  connectLastAndFirstPoint: boolean = false,
) {
  const count = connectLastAndFirstPoint ? array.length : array.length - 1;
  for (let i = 0; i < count; i++) {
    yield [array[i], array[(i + 1) % array.length]] as [T, T];
  }
}

/**
 * Iterates each neighbouring pair in an array.
 * For example: [0,1,2,3,4,5] will yield [0,1],[2,3],[4,5].
 */
export function* pairIterator<T>(array: T[]) {
  if (array.length % 2 !== 0) {
    throw new Error('Array length must be even.');
  }
  for (let i = 0; i < array.length; i += 2) {
    yield [array[i], array[i + 1]];
  }
}
